import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import ExclusiveButton from '@wix/da-ds/pkg/Buttons/ExclusiveButton';
import GiftButton from '../../lego/GiftButton';
import Flex from '@wix/da-ds/pkg/Flex';
import FlexItem from '@wix/da-ds/pkg/Flex/Item';
import { formatDollars, OPTIONAL_DECIMAL_DIGITS } from '../../../../../../utils/formatting';
import { useBuyNowAction, useMakeOfferAction, useManageOfferAction } from '../../hooks';
const BuyerButtons = ({ deviation, adoptableState })=>{
    const { t } = useTranslation();
    const { canBuyNow, canMakeNewOffer, canManageExistingOffer, fixedPrice } = adoptableState;
    const sectionname = 'side-rail';
    const [onMakeOffer, makeOfferBiData] = useMakeOfferAction(deviation, {
        sectionname
    });
    const [onManageOffer, manageOfferBiData] = useManageOfferAction(deviation, {
        sectionname
    });
    const [onBuyNow] = useBuyNowAction(deviation, {
        sectionname,
        purchase_price: fixedPrice
    });
    const isExclusiveGifts = useFlag('exclusive_gifts');
    if (isExclusiveGifts) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, canBuyNow && /*#__PURE__*/ React.createElement(ExclusiveButton, {
            key: "buy-now",
            priority: "primary",
            onClick: onBuyNow,
            biData: BiData({
                evid: 750,
                purchase_price: fixedPrice,
                itemid: deviation.deviationId,
                sectionname: BiContextProvidedValue
            })
        }, t('sidebar.exclusives.buttons.buyer.buyNow', {
            price: formatDollars(fixedPrice, _object_spread_props(_object_spread({}, OPTIONAL_DECIMAL_DIGITS), {
                useGrouping: true
            }))
        })), canMakeNewOffer && /*#__PURE__*/ React.createElement(Flex, {
            fullWidth: true,
            gap: 8
        }, /*#__PURE__*/ React.createElement(FlexItem, {
            grow: true
        }, /*#__PURE__*/ React.createElement(ExclusiveButton, {
            key: "make-offer",
            priority: "secondary",
            onClick: onMakeOffer,
            biData: makeOfferBiData,
            compact: true
        }, t('sidebar.exclusives.buttons.buyer.makeOffer'))), /*#__PURE__*/ React.createElement(FlexItem, {
            grow: true
        }, /*#__PURE__*/ React.createElement(GiftButton, {
            deviation: deviation,
            adoptableState: adoptableState
        }))), canManageExistingOffer && /*#__PURE__*/ React.createElement(ExclusiveButton, {
            key: "manage-offer",
            priority: "secondary",
            onClick: onManageOffer,
            biData: manageOfferBiData
        }, t('sidebar.exclusives.buttons.buyer.manageOffer')));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, canBuyNow && /*#__PURE__*/ React.createElement(ExclusiveButton, {
        key: "buy-now",
        priority: "secondary",
        onClick: onBuyNow,
        biData: BiData({
            evid: 750,
            purchase_price: fixedPrice,
            itemid: deviation.deviationId,
            sectionname: BiContextProvidedValue
        })
    }, t('sidebar.exclusives.buttons.buyer.buyNow', {
        price: formatDollars(fixedPrice, _object_spread_props(_object_spread({}, OPTIONAL_DECIMAL_DIGITS), {
            useGrouping: true
        }))
    })), canMakeNewOffer && /*#__PURE__*/ React.createElement(ExclusiveButton, {
        key: "make-offer",
        priority: "primary",
        onClick: onMakeOffer,
        biData: makeOfferBiData
    }, t('sidebar.exclusives.buttons.buyer.makeOffer')), canManageExistingOffer && /*#__PURE__*/ React.createElement(ExclusiveButton, {
        key: "manage-offer",
        priority: "primary",
        onClick: onManageOffer,
        biData: manageOfferBiData
    }, t('sidebar.exclusives.buttons.buyer.manageOffer')));
};
BuyerButtons.displayName = 'BuyerButtons';
export default BuyerButtons;
